"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _breakpoints = require("../../../../helpers/breakpoints");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledContainer = _styledComponents.default.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: ${props => `calc(${props.theme.gridGutterWidth} * 0.5)`};
    padding-left: ${props => `calc(${props.theme.gridGutterWidth} * 0.5)`};

    ${_breakpoints.breakpointUp.md`
        max-width: ${props => props.fluid ? '100%' : props.theme.breakpoints.md};
    `}

    ${_breakpoints.breakpointUp.lg`
        max-width: ${props => props.fluid ? '100%' : props.theme.breakpoints.lg};
    `}
    
    ${_breakpoints.breakpointUp.xl`
        max-width: ${props => props.fluid ? '100%' : props.theme.breakpoints.xl};
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
var _default = StyledContainer;
exports.default = _default;